import { render, staticRenderFns } from "./pager.vue.html?vue&type=template&id=606847e4&"
import script from "./pager.ts?vue&type=script&lang=ts&"
export * from "./pager.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports